import RestService from "./rest.service";

class launchFormService {
  getFilter() {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/form/launch/filter`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  getListEmployee(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/admin/kpi/form/launch/employee`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  getPrepare(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/admin/kpi/form/launch/prepare`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  launch(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/admin/kpi/form/launch/process`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  getHistory(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/form/launch/history`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  getSummary(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/form/launch/history/summary/` + data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  getViewResult(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/form/launch/history/result/` + data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
}

export default new launchFormService();
